<div class="flex flex-row full-grow-no-shrink-no-basis">
    <!-- CONTENT CARD -->
    <div class="content-card mat-white-bg flex flex-col full-grow-no-shrink-no-basis">

        <!-- CONTENT -->
        <div *ngIf="documentCategoryContents && documentCategoryContents.length > 0" class="content p-30 simple-scroll"
             id="chapterDocument">
            <div class="wrapper">
                <h1 class="title">{{countryName}}</h1>

                <div class="_border">
                    <div class="notification-message-container" style="display: block; width: auto">
                        <div>
                            <span>Note:</span> <span>You are viewing a comparison between the <p class="text-inserted"
                                                                                                 style="font-weight: normal!important;
    display: inline-flex;
    padding: 2px 5px;">Latest Version
            ({{ currentCountryTrackerVersion }})</p> and a <p class="text-removed" style="font-weight: normal!important;
    display: inline-flex;
    padding: 2px 5px;">Previous Version
            ({{ previousCountryTrackerVersion }})</p>. You can return to
            <a class="dynamic-link pointer" (click)="viewLatestVersion()">view the latest version</a>
            at any time.</span>
                        </div>
                    </div>
                    <div *ngFor="let categoryContents of documentCategoryContents" class="chapter-content-container">
                        <particle-document-content-viewer class="document-content-viewer"
                                                          [documentContent]="categoryContents">
                        </particle-document-content-viewer>

                    </div>

                </div>
            </div>
        </div>
        <div *ngIf="documentCategoryContents === undefined || documentCategoryContents.length == 0"
             class="full-grow-no-shrink-no-basis">
            <div class="empty-content ele-center flex flex-col justify-center items-center flex-1-0-100">
                <div class="text-container">
                    <img
                            src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
                            alt="Empty images">
                    <h1>{{message}}</h1>
                </div>
            </div>
        </div>
        <!-- / CONTENT -->
    </div>
    <!-- / CONTENT CARD -->
</div>
